import { alpha, createTheme } from '@mui/material/styles';

/** Blu brand (allineato a R-RAP2 / token UI Cantir) */
const CANTIR_BLUE = '#1B4FD8';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1565C0',   // blue 800
      light: '#1E88E5',
      dark: '#0D47A1',
    },
    secondary: {
      main: '#FF6F00',   // amber 900 (cantiere)
    },
    background: {
      default: '#F5F7FA',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiBox: {
      styleOverrides: {
        // Blu Cantir (stesso token R-RAP2 / form rapportini)
        root: { fontSize: 18, color: '#1B4FD8' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600 },
      },
    },
    /** Toggle, voci di lista, tab, ecc.: selected non più grigio, ma blu Cantir */
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: CANTIR_BLUE,
            backgroundColor: alpha(CANTIR_BLUE, 0.12),
            '&:hover': {
              backgroundColor: alpha(CANTIR_BLUE, 0.2),
            },
          },
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: CANTIR_BLUE,
            backgroundColor: alpha(CANTIR_BLUE, 0.12),
            borderColor: alpha(CANTIR_BLUE, 0.5),
            '&:hover': {
              backgroundColor: alpha(CANTIR_BLUE, 0.2),
            },
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined', fullWidth: true },
    },
  },
});
